// extracted by mini-css-extract-plugin
module.exports = {"marginMode":"MarginOption_marginMode__GKMO6","switch":"MarginOption_switch__n1yrm"};